export default {
    namespaced: true,
    chatbot: {
      input_placeholder: 'Perguntar aqui'
    }
  };  